import { Colors } from '@oy/uicore';
import { StringTemplate, Text } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import { useContext } from 'react';
import { useTranslate } from 'src/hooks';
import { useLegalDocumentData } from 'src/hooks/data/useLegalDocumentData';
import { SignLegalDocumentModalContext } from '../../useSignLegalDocumentModalContext';
import styles from './SignLegalDocumentModalHeader.module.css';
import { getStepTitle } from './helper';
type HeaderProps = {
  selectedDocument?: string;
  onClose: () => void;
  onBackToAllDocument: () => void;
};

export const SignLegalDocumentModalHeader = ({
  selectedDocument,
  onClose,
  onBackToAllDocument,
}: HeaderProps) => {
  const { getTranslation } = useTranslate();
  const { allDocument, payloadToSignDocuments } = useContext(
    SignLegalDocumentModalContext,
  );
  const { mutate } = useLegalDocumentData();

  const totalDocument = allDocument.length - payloadToSignDocuments.length;

  const currentDocument = allDocument.find(
    doc =>
      doc.id === selectedDocument && !payloadToSignDocuments.includes(doc.id),
  );

  const isDocumentNeedToSign = currentDocument?.status === 'NEED_TO_SIGN';

  return (
    <div className={styles.header}>
      <div className={styles.iconContainer}>
        <SystemIcon
          name={selectedDocument ? 'back' : 'close'}
          color={Colors.BLACK100}
          onClick={
            selectedDocument
              ? onBackToAllDocument
              : () => {
                  onClose();
                  mutate();
                }
          }
        />
        <div className={styles.verticalLine} />
      </div>
      <div className={styles.title}>
        <Text textStyle={Text.Style.HeadingSm}>
          {selectedDocument && currentDocument
            ? getStepTitle(currentDocument)
            : getTranslation('common_PKS')}
        </Text>
        {selectedDocument && isDocumentNeedToSign && (
          <Text textStyle={Text.Style.BodySmRegular}>
            <StringTemplate
              str={getTranslation('sign_legal_document_header')}
              template={{
                totalDocument: <b>{totalDocument}</b>,
              }}
            />
          </Text>
        )}
      </div>
      <div></div>
    </div>
  );
};
